<template>
  <div id="app">
    <ImportantDateTermNavigation @ws-change-term="changeTerm"
                                 @ws-load-terms="changeTerm"
                                 @ws-error-load-terms="errorLoadingTerms"></ImportantDateTermNavigation>

    <ImportantDate v-for="date in dates"
                   :key="date.id"
                   :importantDate="date"></ImportantDate>

    <p v-if="dates.length === 0">
      There are no events for this term at this date. Please check back later or subscribe to the <a href="http://mailinglist.wusa.ca/sympa/subscribe/clubs">clubs mailing list</a> for updates.
    </p>

    <Toast position="bottom-right" group="br" /> 
  </div>
</template>

<script>
import ImportantDate from "../components/important-dates/important-date-component.vue";
import ImportantDateTermNavigation from "../components/important-dates/important-date-term-navigation.vue";
import ImportantDatesService from "../services/ImportantDatesService.js";
import Toast from 'primevue/toast/sfc';



export default {
  components: {
    ImportantDate,
    ImportantDateTermNavigation,
    Toast
  },
  data: function () {
    return {
      dates: []   
    }
  },
  computed: {
  },
  async created() {
    this.dates = [];
  },
  methods: { 
    async changeTerm(term) {
      try {
        const importantDateService = new ImportantDatesService();

        const dates = await importantDateService.getDates(term);

        this.dates = dates;
      } catch {
        // TODO: show error using a prime vue toast
        this.$toast.add({severity:'error', summary: 'Error loading important dates.', detail:'An error occured loading the important dates. If the error persists please contact the clubs manager.', group: 'br', life: 5000});
        this.dates = [];
      }
    },
    errorLoadingTerms() {
        this.$toast.add({severity:'error', summary: 'Error', detail:'An error occured loading the terms.', group: 'br', life: 5000});
    }
  }
}
</script>

<style scoped>

</style>
